import { ReportSubscription } from '@/@types/report-subscription';
import { Table } from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';

interface ReportSubscriptionsTableProps {
  data: ReportSubscription[];
  columns: ColumnDefinitionType<ReportSubscription>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof ReportSubscription;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function ReportSubscriptionsTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: ReportSubscriptionsTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
